import {put} from 'redux-saga/effects';
import {watch} from 'store/effects';
import {size} from 'helpers';
import {subscription} from 'store/session';
import {activities} from 'store';

export function* resync() {
  yield watch(activities.storedGoogleEvents, function* (now, prev, action) {
    if (size(now) < size(prev) && action.type == 'SERVER_DATA_RECEIVED') {
      //user possibly removed imported activities on another device
      yield put({ type: 'GOOGLE_CALENDAR_FULL_READ' });
    }
  });
}

export function* session() {
  yield watch(subscription, function* (now, prev) {
    if (prev && prev.premium && !now.premium) {
      yield put({ type: 'GOOGLE_CALENDAR_SIGN_OUT' });
    }
  });
}
